export default {
  'action.duplicate.label': 'Duplicate with translations',
  'action.duplicate.disabled.missing-metadata':
    'The document cannot be duplicated because the metadata document is missing',
  'action.duplicate.disabled.multiple-metadata':
    'The document cannot be duplicated because there are multiple metadata documents',
}
